import { render, staticRenderFns } from "./ScoredDataComponent.vue?vue&type=template&id=b7a88496&scoped=true&"
import script from "./ScoredDataComponent.vue?vue&type=script&lang=js&"
export * from "./ScoredDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScoredDataComponent.vue?vue&type=style&index=0&id=b7a88496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a88496",
  null
  
)

export default component.exports